import { useMutation } from '@apollo/client';
import type { DeleteTagTypesMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteTagTypesDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import { evictField } from '@/utils/graphqlUtils';

import { useDeleteTagTypesTRPC } from './useDeleteTagTypesTRPC';

export const useDeleteTagTypes = () => {
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');

  // GraphQL mutation
  const [deleteTagTypesGraphQL, graphqlState] = useMutation(
    DeleteTagTypesDocument,
    {
      update: (cache) => {
        evictField(cache, 'tag_type');
      },
    }
  );

  // tRPC mutation
  const trpcMutation = useDeleteTagTypesTRPC();

  const deleteTagTypes = async (variables: {
    Ids: string[];
  }): Promise<DeleteTagTypesMutation> => {
    if (trpcEnabled) {
      return trpcMutation.deleteTagTypes(variables);
    }

    const result = await deleteTagTypesGraphQL({
      variables: { Ids: variables.Ids },
    });
    if (!result.data) {
      throw new Error('Failed to delete tag types');
    }

    return result.data;
  };

  if (trpcEnabled) {
    return {
      deleteTagTypes,
      loading: trpcMutation.loading,
      error: trpcMutation.error,
    };
  }

  return {
    deleteTagTypes,
    loading: graphqlState.loading,
    error: graphqlState.error,
  };
};
